import pic51 from './assets/images/51.jpg';
import pic52 from './assets/images/52.jpg';
import pic53 from './assets/images/53.jpg';
import pic54 from './assets/images/54.jpg';

import svg11 from './assets/svg/11.svg';
import svg22 from './assets/svg/22.svg';
import svg63 from './assets/svg/63.svg';
import svg44 from './assets/svg/44.svg';
import svg53 from './assets/svg/53.svg';

const Five = () => (
	  <section style={{paddingTop: "1em"}}>
		<div className="section-num" style={{top: 0}}>5</div>
		<p><img src={pic51} alt="" /></p>
		<div className="wrapper">
			<h2>Pomocí fotosyntézy stromy tvoří kyslík</h2>
			<p className="like-h3">Zdrojem energie pro člověka i strom jsou cukry. Strom si je na rozdíl od nás umí sám vytvářet v listech a jehlicích během fascinujícího jevu, kterému říkáme fotosyntéza.</p>
			<p className="txt-right" style={{marginBottom: ".75em"}}>
				<span className="relative inline-block" style={{maxWidth: "12em"}}>Během fotosyntézy strom doslova během sekundy přemění světlo na&nbsp;hmotu. Potřebuje k tomu ještě oxid uhličitý ze vzduchu a vodu přijímanou kořeny.
					<img src={svg11} className="pointer" style={{top: "80%", right: "90%", maxWidth: "30%"}} alt="" />
				</span>
			</p>
		</div>
		<p><img src={pic52} alt="" /></p>
		<div className="wrapper">
			<p style={{marginTop: "-.75em"}}>
				<span className="relative inline-block" style={{maxWidth: "16em"}}>Při fotosyntéze vzniká kyslík, který stromy vypouští zpět do vzduchu. Dospělý strom ho&nbsp;během roku uvolní tolik, kolik ho potřebuje ročně vdechnout 10 lidí kvůli okysličování krve
					<img src={svg22} className="pointer" style={{bottom: "85%", left: "82%", maxWidth: "15%"}} alt=""/>
				</span>
			</p>
			<h2>Proč se mění barva&nbsp;listů? </h2>
			<p className="like-h3">Strom pohlcuje energii ze světla pomocí rostlinných barviv v listech. Když v nich převládá zelený chlorofyl, jeví se nám jako zelené.</p>
			<p className="txt-right" style={{marginBottom: ".5em"}}>
				<span className="relative inline-block" style={{maxWidth: "14.25em"}}>S pohlcováním světla po celý rok pomáhají žlutá a oranžová barviva. Na stromech je&nbsp;začneme vnímat až na podzim, kdy&nbsp;se&nbsp;chlorofyl v listech rozkládá a&nbsp;postupně z nich mizí.
					<img src={svg53} className="pointer" style={{top: "105%", right: "30%", maxWidth: "30%"}} alt="" />
				</span>
			</p>
		</div>
		<p><img src={pic53} alt="" /></p>
		<div className="wrapper">
			<p style={{maxWidth: "14em"}}><b className="tip">Tip pro tebe:</b> Zajdi na podzim do&nbsp;Prochaskova lesoparku a obdivuj krásy měnících se barev na listech. Nebude náhodou javor mléč, u kterého stojíš, nejbarevnějším stromem ze všech?</p>
			<h2>Opadané listí tvoří&nbsp;půdu</h2>
			<p className="like-h3">V zimě je pro stromy těžké přijímat ze&nbsp;zmrzlé půdy vodu nutnou pro fotosyntézu. Před zimou proto listnaté stromy stahují uložené živiny z listů do&nbsp;větviček a listy nechají upadnout.</p>
			<p className="txt-right" style={{marginBottom: ".75em"}}>
				<span className="relative inline-block" style={{maxWidth: ""}}>V půdě žije spousta hub, bakterií a živočichů, kteří listy konzumují a rozkládají na čím dál menší částečky. Do půdy se tak dostanou zpět živiny, které strom ze země vysál společně s vodou.
					<img src={svg63} className="pointer" style={{top: "105%", left: "80%", maxWidth: "7%"}} alt="" />
				</span>
			</p>
		</div>
		<p><img src={pic54} alt="" /></p>
		<div className="wrapper">
			<p style={{marginTop: "-.75em"}}>
				<span className="relative inline-block" style={{maxWidth: "12em"}}>Ve spadaném listí se přes zimu ukrývá hmyz, žáby i malí hlodavci. Ve hromadách listí často tráví zimní spánek i ježek. 
					<img src={svg44} className="pointer" style={{bottom: "100%", left: "30%", maxWidth: "20%"}} alt="" />
				</span>
			</p>
		</div>
	</section>
);

export default Five;
